import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NoImageFound = () => {
  return <FontAwesomeIcon icon="image" />;
};
